// TODO - remove lint disable when editing this file
/* eslint-disable */
import { Observable } from 'rxjs'
import { errorAction } from '~/redux/commonActions'
import { ACTION_WEBSKED_NEW_PITCH, getWebskedPitches } from '../websked'

export default (action$, store, { serviceResolver }) =>
  action$.ofType(ACTION_WEBSKED_NEW_PITCH).mergeMap((action) => {
    const thirdPartyIntegrationService = serviceResolver(
      'thirdPartyIntegrationService'
    )
    const { storyId, type } = action.payload
    return Observable.from(
      thirdPartyIntegrationService(
        `/websked/#/pitch-form?storyID=${storyId}&type=${type}`,
        ['esc'],
        [900, 650]
      )
    )
      .map((_) => {
        return getWebskedPitches()
      })
      .catch((error) => Observable.of(errorAction(error)))
  })
